package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@JsExport
@Serializable
data class WalmartRequestOTPWithSetupCodeResponse(
    val description: String? = null,
    val email: String? = null,
    val status: String? = null
)